import { inject } from '@angular/core';
import {
  CanActivateChildFn,
  CanActivateFn,
  CanMatchFn,
  Router,
} from '@angular/router';
import { AuthService } from '../services/auth.service';

export const loginUrl = '/seguridad/iniciar';

export const authActivateGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authSrv = inject(AuthService);
  if (authSrv.verify()) {
    return true;
  }
  router.navigate([loginUrl]);
  return false;
};

export const anonymousActivateGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authSrv = inject(AuthService);
  if (!authSrv.verify()) {
    return true;
  }
  router.navigate(['/']);
  return false;
};

export const authMatchGuard: CanMatchFn = () => {
  const router = inject(Router);
  const authSrv = inject(AuthService);
  if (authSrv.verify()) {
    return true;
  }
  router.navigate([loginUrl]);
  return false;
};

export const authActivateChildGuard: CanActivateChildFn = () => {
  const router = inject(Router);
  const authSrv = inject(AuthService);
  if (authSrv.verify()) {
    return true;
  }
  router.navigate([loginUrl]);
  return false;
};
